import { ElementType } from 'react';
import { FormDataConsumer } from 'react-admin';

import { languages } from '@app/utils/languages';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import './styles.css';

interface MultiLingualFieldProps {
  language: string;
  source: string;
  Component: ElementType;
  [x: string]: unknown;
  defaultValue?: any;
}

export const MultiLingualField = ({ Component, language, source, defaultValue, ...props }: MultiLingualFieldProps) => {
  const parse = (value: unknown, lang: string, formData: GenericObject) => {
    if (formData[source]) {
      return {
        ...(formData[source] as GenericObject),
        [lang]: value,
      };
    } else {
      return {
        [lang]: value,
      };
    }
  };

  return (
    <div>
      {languages.map((lang) => (
        <div key={lang.key} className="multilingual-field_container">
          {languages.length > 1 && (
            <img
              alt="test"
              width={30}
              height={20}
              className="multilingual-field_flag-img"
              style={{
                display: language === lang.key ? 'block' : 'none',
              }}
              src={lang.img}
            />
          )}
          <FormDataConsumer>
            {({ formData }) => {
              let dV = parse(defaultValue, lang.key, formData);
              return (
                <div style={{ display: language === lang.key ? 'block' : 'none', width: '100%' }}>
                  <Component
                    key={lang.key}
                    source={`${source}`}
                    data-cy={`${source}_${lang.key}`}
                    {...props}
                    format={(value: GenericObject) => (value ? value[lang.key] : dV ? dV[lang.key] : '')}
                    parse={(value: unknown) => parse(value || defaultValue, lang.key, formData)}
                    defaultValue={defaultValue && dV}
                  />
                </div>
              );
            }}
          </FormDataConsumer>
        </div>
      ))}
    </div>
  );
};
